export default {
  toasts: {
    failed_to_delete_website: 'Nie udało się usunąć strony',
    website_deleted: 'Strona została usunięta',
  },
  delete_model: {
    title: 'Czy na pewno chcesz usunąć stronę?',
    confirm: 'Usuń',
    cancel: 'Anuluj',
  },
  buttons: {
    open_editor: 'Otwórz edytor',
    transfer_website: 'Przenieś stronę',
    delete_site: 'Usuń',
  },
};
